<template>
  <div class="home">
    <TmMain>
      <TmSpinner :show="!showAllow" />
      <TmBox v-show="showAllow" title>
        <TmAlert :icon="alertIcon" :type="alert.type" v-show="alert.show"><span v-html="alert.text" /></TmAlert>
        <div v-show="!alert.show">
            <TmRow>
              <TmCol>
                <strong class="text-size-h2" v-show="!alert.final" v-html="msg" />
              </TmCol>
            </TmRow>
          <TmRow v-if="alert.final" class="res-icons text-center">
            <TmCol>
              <h2 v-if="alert.finalSuccess">Ďakujeme.</h2>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" v-if="alert.finalSuccess">
                <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
              </svg>
              <span v-if="alert.finalSuccess">Platba bola úspešná. Úhradu faktúry sme zaevidovali.</span><br/><span v-if="alert.finalSuccess">Túto stránku môžete teraz pokojne opustiť.</span>
              <h2 v-if="!alert.finalSuccess">Platba je neúspešná</h2>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" v-if="!alert.finalSuccess">
                <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
                <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
              </svg>
              <span v-html="alert.text" v-if="!alert.finalSuccess"></span><br/><span v-if="!alert.finalSuccess">Platbu môžete zopakovať neskôr.</span>
            </TmCol>
          </TmRow>
          <TmDivider />
            <TmRow>
          <TmCol>
            <p>Suma na úhradu<br/>
            <strong class="text-size-h2 text-nowrap" v-text="identsAmount"></strong> </p>
          </TmCol>
          <TmCol>
            <p>
              <span>Variabilný symbol: </span>
              <strong class="text-size-h3" v-text="stringVs"></strong>
            </p>
          </TmCol>
          <TmCol>
            <p>
              <span>Číslo adresáta: </span>
              <strong class="text-size-h3" v-text="idents.ss"></strong>
            </p>
          </TmCol>
          </TmRow>
        <TmDivider />
          <div id="pay-container"></div><p></p>
<!-- 
  hidden after paymenet because option not selected by isVisaCard getter
 -->
          <TmRow v-show="isVisaCard">
            <TmCol>
              <p class="my-1 font-weight-bold">Doplňte údaje vlastníka platobnej karty</p>
              <p class="text-size-sm text-muted">Od 12. októbra 2024 spoločnosť Visa vyžaduje pri platbe meno držiteľa karty, telefónne číslo držiteľa karty a IP adresu zariadenia. Tieto údaje su využité iba v procese uskutočnenia platby.</p>
            </TmCol>
            <TmCol sm="12" md="7" lg="8">
              <TmRow>
                <TmCol sm="12" lg="6">
                  <TmInput label="Krstné meno na karte" @focusout="addValidateInput('givenName')" class="input-dui" v-model="addCustomData.givenName" :invalid="addCustomData.givenNameError && addCustomData.errorsVisible" feedback="Vyplňte meno" @focusin="addCustomData.givenNameError = false" />                              
                </TmCol>
                <TmCol sm="12" lg="6">
                  <TmInput label="Priezvisko na karte" @focusout="addValidateInput('surName')" class="input-dui" v-model="addCustomData.surName" :invalid="addCustomData.surNameError && addCustomData.errorsVisible" feedback="Vyplňte priezvisko" @focusin="addCustomData.surNameError = false" />                              
                </TmCol>
              </TmRow>
            </TmCol>
            <TmCol sm="12" md="7" lg="4">
              <TmInput label="Telefónne číslo držiteľa karty" @focusout="addValidateInput('telephoneNumber')" class="input-dui" v-model="addCustomData.telephoneNumber" :invalid="addCustomData.telephoneNumberError && addCustomData.errorsVisible" feedback="Vyplňte telefónne číslo" @focusin="addCustomData.telephoneNumberError = false" />            
            </TmCol>
            <TmCol sm="12" class="text-muted">
              <TmCheckbox id="storageCheck" @change="storageChange" v-model="addCustomData.storageCheck" label="Uložiť krstné meno, priezvisko na karte a telefónne číslo v tomto prehliadači pre budúce platby"/>
            </TmCol>
          </TmRow>

          <TmButton type="primary" id="submit-button" style="display:none;" class="block">Zaplatiť</TmButton>
<!-- 
  hide manually after payment
 -->
          <div class="banks" v-if="!altsHide && !altsView.altsSuperHide && !alert.final">
            <TmCollapsible title="Online platba vo vašej banke" :visible="altsView.visible" class="mt-4 collapse-text">
                <TmRow class="mt-3">
                  <TmCol sm="12" md="7" lg="6" class="d-flex">
                    <TmCard>
                      <p class="mt-0 mb-2 text-muted">Vyberte svoju banku a prihláste sa do Internet bankingu.</p>
                      <TmRow>
                        <TmCol sm="12" md="6" v-for="sBank in sessionAdditionalData.banks" :key="sBank.img" class="text-center text-md-left">
                        <TmFlex halign="center">
                        <div :class="{ 'frame-border': (sBank.img === 'slsp.jpg') }">
                          <div class="px-2 my-2">
                            <a :href="sBank.url" target="extbank"><img :src="require('@/assets/img/' + sBank.img)" /></a>
                          </div>
                        </div>
                      </TmFlex>
                     </TmCol>
                  </TmRow>    
                </TmCard>
              </TmCol>
                  <TmCol sm="12" md="5" lg="6" class="pt-0 text-center text-md-left">
                    <TmCard>
                      <p class="mt-0 mb-3 text-muted">QR kód nasnímajte v aplikácii banky alebo pri platbe na pošte. Kliknutím na obrázok sa kód uloží do zariadenia.</p>
                    <TmFlex halign="center" class="qrflex">
                      <a :href="qrDownload" target="_self"><img class="qr-style" :src="sessionAdditionalData.imageDataURL" /></a>       
                    </TmFlex>             
                    </TmCard>
                  </TmCol>
                </TmRow>
            </TmCollapsible>
          </div>
          <TmRow v-if="!alert.final">
          <TmCol style="margin-top: 2rem;" class="text-right">
          <small><span>Platenie je zabezpečené v súlade s usmernením PCI DSS.</span></small><img src="@/assets/img/pci-dss-compliant.png" style="height:1.3rem;margin-left:1rem;">
        </TmCol></TmRow>
        </div>
      </TmBox>
    </TmMain>
  </div>
</template>

<script>
import { TmMain, TmBox, TmDivider, TmButton, TmAlert, TmRow, TmCol, TmIcon, TmSpinner, TmFlex, TmInput, TmCheckbox, TmCollapsible, TmCard } from "@tmcz/tmcz-vue-ui"
import LoadingOverlay from "@/views/LoadingOverlay"
import { create as dropinCreate } from "braintree-web-drop-in"
import { removeAccents, visaFormatMsisdn, checkInputByType, appConfig } from "@/components/common"

export default {
  name: 'StartPage',
  components: { TmMain, TmBox, TmDivider, TmButton, TmAlert, LoadingOverlay, TmRow, TmCol, TmIcon, TmSpinner, TmFlex, TmInput, TmCheckbox, TmCollapsible, TmCard },
  data () {
    return {
      msg: String,
      showAllow: false,
      alert: {
        type: 'warning', text: 'Chyba.', show: false, final: false, finalSuccess: true
      },
      idents: {},
      origQuery: '',
      isMulti: false,
      processOpen: true,
      clickDispatched: false,
      sessionAdditionalData: {},
      stringAmount: '',
      stringVs: '',
      altsHide: true,
      altsView: { visible: false, altsSuperHide: false, origQueryObj: {} },
      addCustomData: { methodIsCard: false, cardIsVisa: false, givenName: '', surName: '', telephoneNumber: '', givenNameError: false, surNameError: false, telephoneNumberError: false, errorsVisible: true, storageCheck: false },
      cardIsVisa: false
    } 
  }, 
  created: function() {
  },
  mounted: async function() {
    var that = this
    this.origQuery = this.$route.fullPath;
    this.altsView.origQueryObj = _.clone(this.$route.query);
    var idents =  _.transform(this.$route.query, function (result, val, key) {
        result[key.toLowerCase()] = val;
    });
    this.isMulti = (idents.ss && idents.ins && idents['dunn_cnt']);
    if ((idents.vs && idents.ss && idents.amt) || this.isMulti) {
      if (this.isMulti) {
      idents.ins = this.validateUrlParamPipe(idents.ins);
      var invCount = (idents.ins.split('|')).length;
      if (invCount.toString() == idents['dunn_cnt']) {
        var amountInt = this.getAmountInt(idents.ins);
        this.stringVs = this.findVsNumber(idents, this.isMulti);

        // dunn_falback idents pouzit aj pre link na qr downaload        
        idents.dunn_fallback = { amt: String(amountInt), vs: this.stringVs, ss: idents.ss }
        if (amountInt % 1 == 0) {
          this.stringAmount = amountInt.toString() + '.- €';
        } else {
          this.stringAmount = amountInt.toString().replace(/\./g, ',') + ' €';
        }
      } else {
        that.showAllow = true;
        that.alert = {
          show: true,
          type: 'warning',
          text: 'Platobný link nieje platný.'
          }
        return;
      }
      } else {
        if (isNaN(String(idents.vs).replace(/ /g, '')) || isNaN(String(idents.ss).replace(/ /g, ''))) {
          this.altsHide = true;
          this.altsView.altsSuperHide = true;
        }
        this.stringVs = this.findVsNumber(idents, this.isMulti);
      }
      this.$router.replace('/')
      var res = await this.getSession(idents)
      if (!res.error) {
        if (_.isArray(res.uiSetup)) {
          const uiSetup = {};
          _.each(res.uiSetup, function(uv) {
            uiSetup[uv.name] = uv.value;
          })
          appConfig.visaAdvanced = uiSetup.visaAdvanced === '1';
          appConfig.visaOnlyNotEmpty = uiSetup.visaIsMandatory === '1';
        }
      }
      this.msg = "Platba faktúry <span class=\"text-nowrap\">za služby Telekom</span>"
      if ((this.isMulti) || ((!this.isMulti) && (parseFloat(idents['amt'].replace(/\,/g, '.')) > 0))) {
      this.$http.get('/pb/online-platba/cards/tpay')
      .then(function (resp) {
        that.idents = idents
        that.getBTInstance(resp.data, idents)
      }).catch(function(e){
      that.showAllow = true;
      that.idents = idents
      that.alert = {
        show: true,
        type: 'warning',
        text: 'Platobná brána je dočasne blokovaná. Použite odkaz na úhradu opäť po uplynutí 15 minút.'
        }
      }).finally(function(){
      that.showAllow = true
      })    
    } else {
      that.showAllow = true;
      that.alert = {
        show: true,
        type: 'success',
        text: 'Suma na úhradu je ' + idents['amt'] + '. Zdá sa, že nieje čo platiť.'
        }
    } 
    } else {
      that.showAllow = true;
      that.alert = {
        show: true,
        type: 'danger',
        text: 'Platobná brána nieje dostupná po priamom prístupe. Použite odkaz na úhradu.'
        }
    }
    this.storageCheck('init');
},
methods: {
  getBTInstance: function(tokenResp, idents) {
    var button = document.querySelector('#submit-button'), pAmount = "0";
    if (this.isMulti) {
      pAmount = this.getAmountInt(idents.ins).toFixed(2).toString();
    } else {
      pAmount = parseFloat(idents['amt'].replace(/\,/g, '.')).toFixed(2).toString()
    }
    var that = this
    var mouseEvent = new MouseEvent('click', { bubbles: true,  cancelable: true });
    dropinCreate({
      authorization: tokenResp.token,
      selector: '#pay-container',
      locale: 'sk_SK',
      threeDSecure: true,
      card: {
      overrides: {
          fields: {
            number: {
              formatInput: true,
            }
          }
        }
      },
      googlePay: {
          // googlePayVersion: 2,
          merchantId: '04726102265579945100',
          transactionInfo: {
            totalPriceStatus: 'FINAL',
            totalPrice: pAmount,
            currencyCode: 'EUR',
            countryCode: 'SK'
          },
          button: {
            onClick: function(event) {},
            buttonType: 'checkout',
            buttonLocale: 'sk',
            buttonColor: 'black'
          }
        },
        applePay: {
          displayName: 'Slovak Telekom',
          paymentRequest: {
            total: {
              label: 'Slovak Telekom',
              amount: pAmount
            },
            requiredBillingContactFields: ["postalAddress"]
          }
        }
      }, function (err, instance) {

////        
      if (that.altsView.origQueryObj.debug !== undefined) {
        // alts are hidden if isMulti or (vs or ss) is not numeric
        that.altsHide = false;
      } else {
        that.altsView.altsSuperHide = true;
      }
////
      instance.on('paymentOptionSelected', function (event) {
          if (event.paymentOption == "card"){
            button.style.display = "block"
            that.addCustomData.methodIsCard = true;
          } else {
            button.style.display = "none"
            that.addCustomData.methodIsCard = false;
          }
      })
      instance.on('paymentMethodRequestable', function(pm){
        if (pm.type !== "CreditCard") {
          if (!that.clickDispatched) {
            that.clickDispatched = true;
            button.dispatchEvent(mouseEvent)
          } else {
            button.style.display = "block";
          }
        }
      })
      instance.on('card:cardTypeChange', function (crdData) {
        if (crdData.cards.length === 1) {
          that.addCustomData.cardIsVisa = crdData.cards[0].type === 'visa';
        } else if(crdData.cards.length > 1) {
          that.addCustomData.cardIsVisa = false;
        }
      })
      instance.on('changeActiveView', function(vw) {
        if (vw.newViewId === 'options') {
          button.style.display = "none";
          that.addCustomData.methodIsCard = false;
          that.altsHide = false;        
          that.$nextTick(function(){
            that.altsView.visible = false;  
          })
        } else {
          that.altsView.visible = false;  
          that.$nextTick(function(){
            that.altsHide = true;        
          })
        }
      })
      button.addEventListener('click', function () {
        if (instance.isPaymentMethodRequestable()) {
          that.showAllow = false
          let threeDSConfig = { amount: pAmount, collectDeviceData: true, additionalInformation: { acsWindowSize: '03', ipAddress: (that.sessionAdditionalData.ipc || '127.0.0.1'), userAgent: that.sessionAdditionalData.ua }};
          let newData = {};
          if (that.isVisaCard) {
            that.addCustomData.errorsVisible = appConfig.visaOnlyNotEmpty;
            newData = { billingAddress: { givenName: removeAccents(_.trim(that.addCustomData.givenName)), surname: removeAccents(_.trim(that.addCustomData.surName)), phoneNumber: visaFormatMsisdn(that.addCustomData.telephoneNumber) }};
            if (appConfig.visaOnlyNotEmpty) {
              if (!checkInputByType(that.addCustomData.givenName, 'string') || !checkInputByType(that.addCustomData.surName, 'string') || !checkInputByType(that.addCustomData.telephoneNumber, 'number')) {
                newData = {};
                that.addValidateInput('givenName'), that.addValidateInput('surName'), that.addValidateInput('telephoneNumber');
                that.showAllow = true
                return
              }
            } else {
              if (!checkInputByType(that.addCustomData.givenName, 'string') && !checkInputByType(that.addCustomData.surName, 'string') && !checkInputByType(that.addCustomData.telephoneNumber, 'number')) {
                newData = {};
              }
            }
            threeDSConfig = _.assign(newData, threeDSConfig)
          }
          instance.requestPaymentMethod({threeDSecure: threeDSConfig }, function (err, payload) {
            if (payload) {
              if (((payload.threeDSecureInfo) && (payload.threeDSecureInfo.status == 'authenticate_successful')) || (!payload.threeDSecureInfo)) {
              button.style.display = "none"
              if (that.processOpen) {
                instance.clearSelectedPaymentMethod()
                instance.teardown();
                that.processOpen = false;
              }
              var inData = [], invData = [];
              if (that.isMulti) {
                that.idents.ins = that.validateUrlParamPipe(that.idents.ins);
                var singleInv = that.idents.ins.split('|');
                _.forEach(singleInv, function(vIn, kIn) {
                  invData = vIn.split('_');
                  inData.push({
                    vs: invData[0],
                    ss: that.idents.ss,
                    amt: parseFloat(String(invData[1] || '0').replace(',','.')).toString()
                  })
                })
              } else {
                var sAmt = that.idents.amt;
                if (sAmt !== undefined) { sAmt = parseFloat(String(sAmt).replace(',','.')).toString() }
                inData = [
                  {
                    vs: that.idents.vs,
                    ss: that.idents.ss,
                    amt: sAmt,
                    in: that.idents.in                    
                  }]
              }
              that.$http.post('/pb/online-platba/cards/payment', { btData: payload, stData: inData })
              .then(function(resp){
                  that.alert = {
                    show: false,
                    type: 'success',
                    text: 'Platba bola úspešná. Úhradu faktúry sme zaevidovali.',
                    final: true,
                    finalSuccess: true
                    }
              })
              .catch(function(err){
                if (err.response.status == 403) {
                  that.alert = {
                    show: true,
                    type: 'warning',
                    text: 'Platobná brána je dočasne blokovaná, pokus o úhradu je zrušený. Použite platobný odkaz opäť po uplynutí 15 minút.'
                    }
                }
                else if (err.response.status == 404) {
                  that.alert = {
                    show: true,
                    type: 'danger',
                    text: 'Túto faktúru už nieje možné zaplatiť týmto spôsobom. Platba bola zrušená.'
                    }
                } else if (err.response.status == 500) {
                  that.alert = {
                    show: true,
                    type: 'danger',
                    text: 'Došlo k neočakávanej chybe. Platba bola zrušená.'
                    }
                } else {
                  that.alert = {
                    show: false,
                    type: 'danger',
                    text: err.response.data.locale,
                    final: true,
                    finalSuccess: false
                    }
                }
              })
              .finally(function(){
                that.showAllow = true  
              })
              } else {
                that.showAllow = true  
                that.alert = {
                  show: true,
                  type: 'warning',
                  text: 'Overenie je neúspešné. Platba bola zrušená.'
                }
              }
            } else {
              that.showAllow = true  
              that.alert = {
                show: true,
                type: 'danger',
                text: 'Došlo k neočakávanej chybe: ' + err.message
              }
            }
        });
        }
        that.storageCheck('store');
      })
    })
  },

  findVsNumber(xIdents, xMulti) {
    let xres = xMulti ? xIdents.ss : xIdents.vs
    if (isNaN(xres)) {
      if (xIdents.in || xIdents.ins) {
        if (xIdents.ins) {
          const fListArr = [];
          const invsArr = xIdents.ins.split('|');
          _.forEach(invsArr, function(sv, sk) {
            fListArr.push(sv.split('_')[0]);
          })
          if (fListArr.length > 0) {
            xres = _.join(fListArr, ', ');
          }
        }
        if (xIdents.in) {
          xres = xIdents.in;
        }
      }
    }
    return xres;
  },

  getAmountInt(ins) {
      var tmpAmount = 0;
      ins = this.validateUrlParamPipe(ins);
      _.forEach(ins.split('|'), function(iv, ik) {
        tmpAmount += parseFloat((iv.split('_')[1] || '0').replace(/\,/g, '.'));
      })
      return (Math.round(tmpAmount * 100) / 100);
  },

  getSession: async function(idents) {
    try {
      const sessionData = await this.$http.put('/pb/online-platba/cards/session', idents)
      this.sessionAdditionalData = sessionData.data.additionalData || {};
      return sessionData.data
    } catch(e) {
      this.showAllow = true;
      this.alert = {
        show: true,
        type: 'danger',
        text: 'Platobná brána je dočasne blokovaná. Použite odkaz na úhradu opäť po uplynutí 15 minút.'
      }
      return { error: e.message }
    }
  },

  validateUrlParamPipe(uparam) {
    if ((uparam).replace(/ /g, '').slice(-1) === '|') {
        return uparam.slice(0, -1);    
    } else {
      return uparam;
    }
  },

  addValidateInput(adModel) {
    switch(adModel) {
      case 'givenName':
      case 'surName':
        this.addCustomData[adModel + 'Error'] = !checkInputByType(this.addCustomData[adModel], 'string');        
        break;
      case 'telephoneNumber':
        this.addCustomData[adModel + 'Error'] = !checkInputByType(this.addCustomData[adModel], 'number');        
      break;
    }
  },

  storageChange(el) {
    if (el) {
      localStorage.setItem(appConfig.storageItemName, JSON.stringify({ state: el, givenName: this.addCustomData.givenName, surName: this.addCustomData.surName, telephoneNumber: this.addCustomData.telephoneNumber }))
    } else {
      localStorage.removeItem(appConfig.storageItemName)
    }
  },

  storageCheck(action) {
    if (action === 'init') {
      const storageVal = localStorage.getItem(appConfig.storageItemName);
      if (storageVal !== null) {
        try {
          const pStorageVal = JSON.parse(storageVal);
          this.addCustomData.givenName = pStorageVal.givenName;
          this.addCustomData.surName = pStorageVal.surName;
          this.addCustomData.telephoneNumber = pStorageVal.telephoneNumber;
          this.addCustomData.storageCheck = pStorageVal.state;
        } catch(e) {}
      }
    }
    if (action === 'store') {
      if (this.addCustomData.storageCheck) {
        localStorage.setItem(appConfig.storageItemName, JSON.stringify({ state: true, givenName: this.addCustomData.givenName, surName: this.addCustomData.surName, telephoneNumber: this.addCustomData.telephoneNumber }))
      }
    }
  }
},
computed: {
  identsAmount: function() {
    if (this.idents.amt) {
      if (parseFloat((this.idents.amt).replace(/\,/g, '.'))%1 === 0) {
        return (parseInt(this.idents.amt)).toString().replace(/\./g, ',') + '.- €'
      } else {
        return (parseFloat((this.idents.amt).replace(/\,/g, '.')).toFixed(2)).toString().replace(/\./g, ',') + ' €'
      }
    } else {
      return this.stringAmount
    }
  },
  alertIcon: function() {
    return this.alert.type === "success" ? "check-fill" : "exclamation-fill";
  },
  qrDownload: function() {
    if (this.isMulti && this.idents['dunn_fallback']) {
      return `/pb/online-platba/qr?amt=${this.idents['dunn_fallback'].amt}&ss=${this.idents['dunn_fallback'].ss}&vs=${this.idents['dunn_fallback'].vs}`
    } else {
      return '/pb/online-platba/qr' + (this.origQuery || '/').slice(1);
    }
  },
  isVisaCard: function() {
    return this.addCustomData.cardIsVisa && this.addCustomData.methodIsCard && appConfig.visaAdvanced;
  }
},
watch: {
  isMulti(val){ 
    if (val){
      this.altsHide = val;
      this.altsView.altsSuperHide = val;
    }
  }
}
}
</script>
<style>
[data-braintree-id=choose-a-way-to-pay], [data-braintree-id=upper-container] * {
  font-family: sans-serif;
}

</style>
